package org.example.project.planner.components

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.AlertDialog
import androidx.compose.material3.Button
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.Icon
import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import org.example.project.planner.BlockDraft
import org.example.project.planner.EventFormDraft
import org.example.project.ui.icons.AppIcons
import org.example.project.ui.theme.LocalPlayfulShapes
import org.example.project.ui.theme.PlayfulColors

@Composable
fun EventDetailView(
    isCreate: Boolean,
    draft: EventFormDraft,
    isSaving: Boolean = false,
    onNameChange: (String) -> Unit = {},
    onDateChange: (String) -> Unit = {},
    onStartTimeChange: (String) -> Unit = {},
    onEndTimeChange: (String) -> Unit = {},
    onOpenAddBlockTypePicker: () -> Unit,
    onAddBlockAt: (startTime: String, endTime: String) -> Unit,
    isTimelineEditMode: Boolean = false,
    selectedBlockId: String? = null,
    onSelectBlock: (String?) -> Unit = {},
    onEditBlockClick: (BlockDraft) -> Unit,
    onDeleteBlockClick: (String) -> Unit,
    onShiftBlock: (blockId: String, deltaMinutes: Int) -> Unit,
    onResizeBlockStart: (blockId: String, deltaMinutes: Int) -> Unit,
    onResizeBlockEnd: (blockId: String, deltaMinutes: Int) -> Unit,
    onSaveClick: () -> Unit = {},
    onDeleteEventClick: () -> Unit,
    modifier: Modifier = Modifier
) {
    val scrollState = rememberScrollState()
    val shapes = LocalPlayfulShapes.current
    var showDeleteConfirmation by remember { mutableStateOf(false) }

    Column(
        modifier = modifier
            .fillMaxSize()
            .verticalScroll(scrollState)
            .padding(16.dp)
    ) {
        Spacer(modifier = Modifier.height(14.dp))

        // Vertical Timeline View
        VerticalTimelineView(
            eventStartTime = draft.startTime,
            eventEndTime = draft.endTime,
            blocks = draft.blocks,
            isTimelineEditMode = isTimelineEditMode,
            selectedBlockId = selectedBlockId,
            onSelectBlock = onSelectBlock,
            onEditBlock = onEditBlockClick,
            onDeleteBlock = onDeleteBlockClick,
            onShiftBlock = onShiftBlock,
            onResizeBlockStart = onResizeBlockStart,
            onResizeBlockEnd = onResizeBlockEnd,
            onAddBlockAt = onAddBlockAt,
            onOpenAddBlockTypePicker = onOpenAddBlockTypePicker
        )

        // Delete Event Action (for existing events)
        if (!isCreate) {
            Spacer(modifier = Modifier.height(24.dp))
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.End,
                verticalAlignment = Alignment.CenterVertically
            ) {
                OutlinedButton(
                    onClick = { showDeleteConfirmation = true },
                    shape = shapes.button,
                    border = BorderStroke(1.dp, PlayfulColors.ErrorBorder),
                    colors = ButtonDefaults.outlinedButtonColors(
                        contentColor = PlayfulColors.Error
                    )
                ) {
                    Icon(
                        imageVector = AppIcons.Delete,
                        contentDescription = null,
                        tint = PlayfulColors.Error,
                        modifier = Modifier.size(16.dp)
                    )
                    Spacer(modifier = Modifier.width(6.dp))
                    Text("Usuń wydarzenie", fontWeight = FontWeight.Medium)
                }
            }
        }

        // Bottom spacer to ensure end content is never obscured by the FloatingActionButton
        Spacer(modifier = Modifier.height(80.dp))
    }

    if (showDeleteConfirmation) {
        AlertDialog(
            onDismissRequest = { showDeleteConfirmation = false },
            title = {
                Text(
                    text = "Usuń wydarzenie",
                    fontWeight = FontWeight.Bold,
                    fontSize = 17.sp,
                    color = PlayfulColors.TextPrimary
                )
            },
            text = {
                Text(
                    text = "Czy na pewno chcesz usunąć wydarzenie „${draft.name.ifBlank { "Nowe wydarzenie" }}”? Tej operacji nie można cofnąć.",
                    fontSize = 14.sp,
                    color = PlayfulColors.TextSecondary
                )
            },
            confirmButton = {
                TextButton(
                    onClick = {
                        showDeleteConfirmation = false
                        onDeleteEventClick()
                    }
                ) {
                    Text(
                        text = "Usuń",
                        color = PlayfulColors.Error,
                        fontWeight = FontWeight.Bold
                    )
                }
            },
            dismissButton = {
                TextButton(onClick = { showDeleteConfirmation = false }) {
                    Text(
                        text = "Anuluj",
                        color = PlayfulColors.TextSecondary
                    )
                }
            }
        )
    }
}
